import { hanldeRoomParticipantExceed } from "../../../actions/onLoadFunctionAction";
import { handleRoomAlertAPI } from "../../../actions/recordingAction";
import reduxStore from "../../../configureEnvStore";
import { CALLSTATS_APPID, CALLSTATS_APPSECRET, ROOM_TYPE } from "../../../constants/Constants";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../../../constants/PublicVariables";
import Localize from "../../../locale/Localize";
import callStatsService from "../../../services/callStatsService";
import { addClearFireBaseDBTime, LogFirebase } from "../../../services/firestore";
import { addLogsForRedirectURL, loadDetectRTC } from "../../../shared/function";
import { showMeRoomTypeIsGORoom, showMeRoomTypeIsGoRoomOrP2P } from "../twilioCallUtility";
import { handleEndCallFunc } from "./roomFunction";
import { setActiveRoom } from "./setActiveRoom";

export const handleRoomSuccess = (room, joinMeetingData, ldFlags) => {
    const { agentPortalName, guestPortalName } = reduxStore.getState().language;
    if (!showMeRoomTypeIsGoRoomOrP2P(joinMeetingData?.sessionConfigurations)) {
        room.localParticipant.setNetworkQualityConfiguration({
            local: 3,
            remote: 3,
        });
    }
    //initialize call stats data object
    callStatsService.initCallStats();

    CALL_DATA.localIdentity = room.localParticipant.identity;
    CALL_DATA.participantIdentity = room.localParticipant.identity;
    LogFirebase("TwilioEvents", "room_connected", {
        sid: room.sid,
        room_name: room.name,
        local_identity: room.localParticipant.identity,
    });

    //if Launch Darkly flag is TRUE then only send data to callstats.io
    if (ldFlags.callstatsIoIntegration) {
        const AppID = CALLSTATS_APPID;
        const AppSecret = CALLSTATS_APPSECRET;
        const userDetail = {};

        if (GLOBAL_MEETING_DATA.isAgent) {
            // agent
            userDetail.userName = GLOBAL_MEETING_DATA.blitzzUserName.toString() + " (" + agentPortalName + ")";
        } else {
            // guest user
            userDetail.userName = "Guest";
        }
        userDetail.aliasName = CALL_DATA.memberId.toString();
        userDetail.domain = GLOBAL_MEETING_DATA.isAgent ? agentPortalName : guestPortalName;

        window.callstatstwiliovideo(room, false, AppID, AppSecret, userDetail);
    }
    setActiveRoom(room);
    addClearFireBaseDBTime();
    addLogsForRedirectURL(); // log for url params
    LogFirebase("LaunchDarklyInfo", "ld_flags", ldFlags);
    loadDetectRTC();
    console.log("room", room);
};

export const handleRoomError = (error, joinMeetingData) => {
    console.error("Error joining the call", error);
    const localisedValues = Localize[PublicVariables.currentLanguageObj?.languageCode];
    LogFirebase("TwilioEvents", "callConnectError", {
        error_code: error.code,
        error_message: error.message,
    });
    if (error.code == 8) {
        handleEndCallFunc();
        alert(localisedValues?.unable_to_access_mircrophone_or_camera + " " + localisedValues?.be_sure_to_allow_access_in_browser);
        return;
    }
    if (error.code == 53105) {
        if (showMeRoomTypeIsGORoom(joinMeetingData?.sessionConfigurations)) {
            handleRoomAlertAPI(ROOM_TYPE.GO);
        } else {
            handleRoomAlertAPI(ROOM_TYPE.SMALL);
        }
        reduxStore.dispatch(hanldeRoomParticipantExceed(true));
        handleEndCallFunc();
        return;
    }
    if (error.message == "Requested device not found") {
        handleEndCallFunc();
        alert(error.message + ". " + localisedValues?.make_sure_you_have_microphone_camera_attached);
        return;
    }
    handleEndCallFunc();
};
